var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Mdg2Response } from './index';
import { timeToMilliseconds } from '../types';
var KeyValueResponse = (function (_super) {
    __extends(KeyValueResponse, _super);
    function KeyValueResponse(raw) {
        var _this = _super.call(this, raw) || this;
        if (_this.raw.value === undefined) {
            throw new TypeError('Value is undefined');
        }
        _this._keyExists = _this.raw.key_exists === 1;
        _this._value = _this.raw.value.value;
        _this._lastUpdate = _this.raw.last_update.microseconds;
        _this._validBefore = _this.raw.valid_before.microseconds;
        return _this;
    }
    Object.defineProperty(KeyValueResponse.prototype, "key", {
        get: function () {
            return this._key;
        },
        set: function (key) {
            this._key = key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyValueResponse.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyValueResponse.prototype, "keyExists", {
        get: function () {
            return this._keyExists;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyValueResponse.prototype, "lastUpdate", {
        get: function () {
            return this._lastUpdate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyValueResponse.prototype, "validBefore", {
        get: function () {
            return this._validBefore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyValueResponse.prototype, "lastUpdateInMilliseconds", {
        get: function () {
            return parseInt(timeToMilliseconds(this._lastUpdate));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyValueResponse.prototype, "validBeforeInMilliseconds", {
        get: function () {
            return parseInt(timeToMilliseconds(this._validBefore));
        },
        enumerable: false,
        configurable: true
    });
    return KeyValueResponse;
}(Mdg2Response));
export { KeyValueResponse };
//# sourceMappingURL=KeyValueResponse.js.map